import React from 'react';
import { withRouter } from 'react-router-dom';

import { ratingTypes } from '../../../utils/constants';
import { sportTypeIds } from '../../../utils/eventConstants';
import { formatEventDate } from '../../../utils/formatting';

import styles from './eventItem.scss';
import { EventTypes } from '../../../utils/clubs';

class EventHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { startDate, endDate, eventId, isTms, isDualMatch, eventName, draw, auth, isProProfile, timeZoneValue, isLeaguesMatch, sportTypeId, results = [], eventType, history } = this.props;
        const userLoggedIn = auth && auth.user;
        const getRatingTitle = () => {
            if (sportTypeId) {
                if (sportTypeId === 1) {
                    return ratingTypes.tennis;
                }
                if (sportTypeId === 2) {
                    return ratingTypes.pickleball;
                }
            }

            const hasTennisResults = results.filter(result => result.sportTypeId === sportTypeIds.TENNIS).length > 0;
            const hasPickleballResults = results.filter(result => result.sportTypeId === sportTypeIds.PICKLEBALL).length > 0;

            if (hasTennisResults && !hasPickleballResults) {
                return ratingTypes.tennis;
            }
            if (!hasTennisResults && hasPickleballResults) {
                return ratingTypes.pickleball;
            }
            return `${ratingTypes.tennis} / ${ratingTypes.pickleball}`;
        };

        const isLegacyEvent = eventType === EventTypes.LEGACY;
        const shouldDisplayEventHyperlink = !!eventId && !isLegacyEvent && (isTms || isDualMatch);

        return (
            <div className={`${styles.eventHeaderContainer}`}>
                <div className={`${styles.eventHeader}`} data-testid="result.event-item.event-header">
                    <div className="row">
                        <div className={`col-7 col-md-9 ${styles.eventName}`}>
                            <span
                                className={`${shouldDisplayEventHyperlink ? 'text-teal cursor-pointer' : ''}`}
                                onClick={() => {
                                    if (shouldDisplayEventHyperlink) {
                                        if (isTms) {
                                            history.push(`/events/${eventId}`);
                                        }
                                    }
                                }}
                            >
                                {eventName}
                            </span>
                            {draw && draw.name && (
                                <div className={`${styles.drawName}`}>
                                    <span className={`${styles.middleDot}`}>&nbsp;</span>{draw.name}
                                </div>
                            )}
                        </div>
                        <div className={`col-5 col-md-3 ${styles.eventTime}`}>
                            {formatEventDate(startDate, endDate, timeZoneValue)}
                        </div>

                    </div>
                </div>
                <div className={`d-none d-md-block ${styles.matchHeaders}`}>
                    <div className={`d-flex flex-row`}>
                        <div className={`${styles.data}`}>
                            <div className={`d-flex flex-row ${styles.team}`}>
                                <div className={`col-4 ${styles.playerDetailsContainer}`}>
                                    Players
                                </div>
                                <div className={`col-${isLeaguesMatch ? '2' : '4'} ${styles.utrContainer}`}>
                                    {(userLoggedIn || isProProfile) && (
                                        <>
                                            {getRatingTitle()}
                                        </>
                                    )}
                                </div>
                                {isLeaguesMatch && (
                                    <div className={`col-3`}>
                                        <>Team</>
                                    </div>
                                )}
                                <div className={`col-${isLeaguesMatch ? '2' : '4'} ${styles.scoresConatiner}`}>
                                    Score
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(EventHeader);
